
<style>

  .toolbar {
    /* position: fixed; */
    top: 0;
    left: 0;
    right: 0;
    /* height: 60px; */
    /* display: flex; */
    /* height: auto; */
    align-items: center;
    background-color: #1976d2;
    color: white;
    font-weight: 600;
    z-index: 9;
  }

  .top-nav {
    margin-bottom: 1rem;
  }

</style>

<!-- Toolbar -->
<div class="top-con full-height">
  <div class="wrapper-con">
    <div class="toolbar" role="banner">
    
      <div class="top-nav">
        <nav class="navbar navbar-expand-lg navbar-dark bg-none">
        <a class="navbar-brand" href="#">
          <img
            width="40"
            alt="Angular Logo"
            src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNTAgMjUwIj4KICAgIDxwYXRoIGZpbGw9IiNERDAwMzEiIGQ9Ik0xMjUgMzBMMzEuOSA2My4ybDE0LjIgMTIzLjFMMTI1IDIzMGw3OC45LTQzLjcgMTQuMi0xMjMuMXoiIC8+CiAgICA8cGF0aCBmaWxsPSIjQzMwMDJGIiBkPSJNMTI1IDMwdjIyLjItLjFWMjMwbDc4LjktNDMuNyAxNC4yLTEyMy4xTDEyNSAzMHoiIC8+CiAgICA8cGF0aCAgZmlsbD0iI0ZGRkZGRiIgZD0iTTEyNSA1Mi4xTDY2LjggMTgyLjZoMjEuN2wxMS43LTI5LjJoNDkuNGwxMS43IDI5LjJIMTgzTDEyNSA1Mi4xem0xNyA4My4zaC0zNGwxNy00MC45IDE3IDQwLjl6IiAvPgogIDwvc3ZnPg=="
          />
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
      
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav mr-auto">
            <li class="nav-item active">
              <a class="nav-link" href="#">Audio Player <span class="sr-only">(current)</span></a>
            </li>
          </ul>
    
          <ul class="navbar-nav ml-auto">
            <li class="nav-item">
              <a class="nav-link" [routerLink]="['home']">Player</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" [routerLink]="['publish']">Publish</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" *ngIf="!auth.isAuthenticated" [routerLink]="['login']">Login</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" *ngIf="auth.isAuthenticated" [routerLink]="['profile', user?.id]">Profile</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" *ngIf="auth.isAuthenticated" (click)="auth.logout()">Logout</a>
            </li>
            <li class="nav-item" >
              <a class="nav-link" *ngIf="!auth.isAuthenticated" [routerLink]="['register']">Register</a>
            </li>
          </ul>
        </div>
      </nav>
      </div>
    </div>
    
    
    <div class="container-fluid">
      <router-outlet></router-outlet>
    </div>
  </div>
  
  <div class="footer">
    <!-- <app-footer></app-footer> -->
  </div>
</div>
